import React, { useEffect, useState } from 'react';

const CONFIRM_WORD = 'УДАЛИТЬ';

/**
 * Модальное подтверждение массового удаления (вместо window.prompt).
 */
const DeleteAllConfirmModal = ({
  open,
  onClose,
  onConfirm,
  total = 0,
  cityName = '',
  scheduleLabel = 'графика',
  loading = false,
}) => {
  const [step, setStep] = useState(1);
  const [typed, setTyped] = useState('');

  useEffect(() => {
    if (open) {
      setStep(1);
      setTyped('');
    }
  }, [open]);

  if (!open) return null;

  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget && !loading) onClose();
  };

  const goStep2 = () => setStep(2);

  const handleFinalConfirm = () => {
    if (typed.trim() !== CONFIRM_WORD) return;
    onConfirm();
  };

  return (
    <div
      className="delete-all-modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="delete-all-modal-title"
      onClick={handleBackdrop}
    >
      <div className="delete-all-modal glass-panel" onClick={(e) => e.stopPropagation()}>
        <h3 id="delete-all-modal-title" style={{ margin: '0 0 12px' }}>
          Удалить все записи
        </h3>

        {step === 1 ? (
          <>
            <p style={{ margin: '0 0 8px', color: 'var(--text-primary)' }}>
              Будет удалено <strong>{total}</strong> строк {scheduleLabel} для объекта{' '}
              <strong>«{cityName}»</strong>.
            </p>
            <p style={{ margin: '0 0 20px', color: 'var(--text-muted)', fontSize: 14 }}>
              Действие необратимо. Продолжить?
            </p>
            <div className="delete-all-modal__actions">
              <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
                Отмена
              </button>
              <button type="button" className="btn btn-danger" onClick={goStep2}>
                Продолжить
              </button>
            </div>
          </>
        ) : (
          <>
            <p style={{ margin: '0 0 12px', color: 'var(--text-muted)', fontSize: 14 }}>
              Для подтверждения введите <strong>{CONFIRM_WORD}</strong> (заглавными буквами):
            </p>
            <input
              type="text"
              className="form-control"
              value={typed}
              onChange={(e) => setTyped(e.target.value)}
              placeholder={CONFIRM_WORD}
              autoFocus
              disabled={loading}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && typed.trim() === CONFIRM_WORD) handleFinalConfirm();
              }}
            />
            <div className="delete-all-modal__actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setStep(1)}
                disabled={loading}
              >
                Назад
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleFinalConfirm}
                disabled={loading || typed.trim() !== CONFIRM_WORD}
              >
                {loading ? 'Удаление…' : 'Удалить всё'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default DeleteAllConfirmModal;
